var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 16.25H60L55 22.75L50 16.25ZM16.6667 6.5H63.3333C65.1014 6.5 66.7971 7.18482 68.0474 8.40381C69.2976 9.62279 70 11.2761 70 13V65C70 68.6075 67.0333 71.5 63.3333 71.5H16.6667C14.8986 71.5 13.2029 70.8152 11.9526 69.5962C10.7024 68.3772 10 66.7239 10 65V13C10 9.425 13 6.5 16.6667 6.5ZM16.6667 13V26H63.3333V13H16.6667ZM16.6667 65H63.3333V32.5H16.6667V65ZM23.3333 39H56.6667V45.5H23.3333V39ZM23.3333 52H56.6667V58.5H23.3333V52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxIcon);
export default __webpack_public_path__ + "static/media/tax-icon.c4d050677c252cc5a84e6043bae6d8cc.svg";
export { ForwardRef as ReactComponent };